export function truncateMessage(message: string, maxLength = 200) {
  if (typeof message !== 'string') return message;

  return message.length > maxLength ? message.slice(0, maxLength) + '...' : message;
}
